import { Slide, toast, TypeOptions } from "react-toastify";
import { CustomToast } from "../components";

export const showToast = (message: string, type?: TypeOptions) =>
  toast(CustomToast, {
    type,
    position: "top-center",
    autoClose: 2500,
    hideProgressBar: true,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    closeButton: false,
    transition: Slide,
    icon: false,
    data: {
      message,
    },
  });
